import React, {Fragment, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import useAntTable from "../../utils/useAntTable";
import * as api from '../../apis/product'
import * as categoryApi from "../../apis/productCategory";
import StandardTable from "../../components/StandardTable";
import {Button, Form, Input} from "antd";
import styles from "./index.module.css"
import CategoryCascader from "../../components/CategoryCascader";
import {useRequest} from "ahooks";
import {Simulate} from "react-dom/test-utils";
import withAuth from "../../utils/withAuth";


const ExportButton = withAuth('export', Button);
export default function ProductQty() {

    const {tableProps, form, search, refresh, download, downloading} = useAntTable(api.getProductsQty, {downloadUrl: api.exportProductQtyUrl})
    const [categories, setCategories] = useState([]);

    const {loading: loadingProductCategory} = useRequest(categoryApi.getCategoriesDict, {
        onSuccess(res) {
            setCategories(res.data.data);
        }
    });

    const columns = [
        {
            title: '商品编码',
            dataIndex: 'code'
        },
        {
            title: '商品名称',
            dataIndex: 'name'
        },
        {
            title: '规格型号',
            dataIndex: 'specification'
        },
        {
            title: '产品线',
            dataIndex: 'categoryName',
            render: (value?: string) => value?.replace("//", '')?.replaceAll('/', ' / ')
        },
        {
            title: '计量单位',
            dataIndex: 'unit'
        },
        {
            title: '即时库存',
            dataIndex: 'erpInventory'
        },
        {
            title: 'D365在单',
            dataIndex: 'erpOccupy'
        },
        {
            title: 'DMS在单',
            dataIndex: 'dmsOrderQty'
        },
        {
            title: '不可售库存',
            dataIndex: 'dmsOccupy'
        },
        {
            title: '可用库存',
            dataIndex: 'availableQty'
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable {...tableProps} columns={columns} submit={search.submit} search={search} form={form}
                           rowKey={'id'} toolbar={
                <div className={styles.toolbar}
                     style={{width: '100%', display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                    <div>
                        <Form form={form} layout={'inline'}>
                            <Form.Item name={'categoryId'}>
                                <CategoryCascader onBlur={search.submit} style={{width: 200}}
                                                  placeholder={'请选择产品线'} options={categories} changeOnSelect
                                                  fieldNames={{label: "name", children: "children", value: "id"}}/>
                            </Form.Item>
                            <Form.Item name={'code'}>
                                <Input style={{width: 200}} onBlur={search.submit} placeholder={'请输入商品名称/编码'}/>
                            </Form.Item>
                        </Form>
                    </div>
                    <ExportButton onClick={download} loading={downloading} type={'primary'}>导出</ExportButton>
                </div>
            }/>
        </PageHeaderLayout>
    )
}
